/* src/app/bulk-reveal-modal/bulk-reveal-modal.component.scss */
.camp-modal {
  width: 259px;
  height: 103px;
  flex-grow: 0;
  padding: 20px;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  background-color: #fff;
}
.info-modal {
  padding: 16px 14px 16px 16px;
  border: solid 1px #d9d9d9;
  background-color: #fff8e7;
}
.progress {
  display: flex;
  overflow: hidden;
  font-size: 0.75rem;
  border-radius: 15px;
}
.progress .progress-bar {
  display: flex;
  flex-direction: column;
  height: 13px;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  transition: width 0.6s ease;
}
.mat-progress-bar {
  height: 8px !important;
}
.mat-progress-bar-buffer {
  background-color: white !important;
}
.mat-progress-bar-fill::after {
  background-color: #FFD3A3 !important;
}
.preference-btn mat-radio-button {
  font-size: 14px;
  line-height: 1.5;
  color: #484b59;
  font-family: Poppins;
  margin-left: 1px;
}
/*# sourceMappingURL=bulk-reveal-modal.component-QSUH2KYL.css.map */
